<template>
    <div class="c-history_previous">
        <div class="c-history_previous__heading">
            <h4 class="c-history_previous__heading-title">Poprzednia wizyta</h4>
            <h4 class="c-history_previous__heading-date"><strong>{{ date }}</strong> {{ time }}</h4>
        </div>

        <div class="c-history_previous__content">
            <slot></slot>
        </div>
        <div class="c-history_previous__copy">
            <button
                type="button"
                class="c-history_previous__copy-btn"
                @click="copy">
                Kopiuj do bieżącej wizyty
            </button>
        </div>
    </div>
</template>


<script>

import moment from 'moment'
import {mapGetters} from 'vuex'

export default {

    name: 'VisitHistoryPrevious',

    computed: {
        ...mapGetters(['visit']),
        date() {
            return moment(this.visit.event.start).format('DD.MM.YYYY')
        },
        time() {
            return moment(this.visit.event.start).format('HH:mm')
        }
    },

    methods: {
        copy() {
            this.$emit('copy')
        }
    }

}
</script>


<style lang="scss">

@import '~Style/_utils.scss';

.c-history_previous {
    background-color: #FAFAFC;
    border-radius: .25em;
    padding: 1.5em;
    padding-bottom: 1em;
    margin-bottom: 2em;
    font-size: 0.9rem;

    @include bp($screen-md) {
        padding: 1rem;
    }
    &__heading {
        margin-bottom: 1em;
        display: flex;
        justify-content: space-between;
        align-items: flex-start;

        &-title {
            font-size: 1em;
            color: $c-primary;
        }
    }
    &__empty {
        font-size: 1.2em;
        color: $c-secondary;
        text-align: center;
        width: 100%;
    }

    &__copy {
        padding-top: 1em;
        text-align: right;

        &-btn {
            cursor: pointer;
            display: inline-block;
            border: 0;
            background-color: transparent;
            color: #637280;
            font-weight: 800;
            padding: .2em 0 .2em 2.5em;
            background-image: url('#{$icons}/copy.svg');
            background-position: 0 center;
            background-size: 1.4em 1.4em;
            background-repeat: no-repeat;
        }
    }
}

</style>
